export default "__VITE_ASSET__Bo4_FHSc__"